__turbopack_context__.v({
  "base": "VRc4Cq_base",
  "chip": "VRc4Cq_chip",
  "line": "VRc4Cq_line",
  "shimmer": "VRc4Cq_shimmer",
  "square": "VRc4Cq_square",
});
